import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IconButton, InputAdornment, TextField, } from '@mui/material';
const QuantityButton = ({ onClick, disabled, children }) => (_jsx(IconButton, { size: "small", onClick: (e) => {
        e.preventDefault();
        e.stopPropagation();
        onClick();
    }, disabled: disabled, sx: {
        padding: '4px',
        color: 'text.primary',
        '&:hover': {
            backgroundColor: 'grey.100',
        },
        '&:disabled': {
            color: 'text.disabled',
        },
    }, children: children }));
const QuantityField = ({ setQuantity, quantity, minQuantity = 1, maxQuantity = 10, disabled, }) => {
    const changeQuantity = (delta) => {
        setQuantity(Math.max(minQuantity, Math.min(maxQuantity, quantity + delta)));
    };
    return (_jsx(TextField, { type: "number", size: "small", value: quantity, disabled: disabled, onClick: (e) => {
            e.preventDefault();
            e.stopPropagation();
        }, onChange: (e) => {
            const newQuantity = Math.max(minQuantity, Math.min(maxQuantity, Number(e.target.value) || 1));
            setQuantity(newQuantity);
        }, InputProps: {
            inputProps: {
                min: minQuantity,
                max: maxQuantity,
                style: {
                    textAlign: 'center',
                    fontSize: '0.875rem',
                    fontWeight: 500,
                },
            },
            startAdornment: (_jsx(InputAdornment, { position: "start", children: _jsx(QuantityButton, { onClick: () => changeQuantity(-1), disabled: disabled || quantity <= minQuantity, children: _jsx("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M2.75 7H11.25", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round" }) }) }) })),
            endAdornment: (_jsx(InputAdornment, { position: "end", children: _jsx(QuantityButton, { onClick: () => changeQuantity(1), disabled: disabled || quantity >= maxQuantity, children: _jsxs("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [_jsx("path", { d: "M2.75 7H11.25", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round" }), _jsx("path", { d: "M7 2.75L7 11.25", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round" })] }) }) })),
        }, sx: {
            width: 120,
            '& .MuiOutlinedInput-root': {
                '& fieldset': {
                    borderColor: 'grey.300',
                },
                '&:hover fieldset': {
                    borderColor: 'grey.400',
                },
                '&.Mui-focused fieldset': {
                    borderColor: 'primary.main',
                },
            },
            '& .MuiInputBase-input': {
                // Remove spinner buttons from number input
                '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                    WebkitAppearance: 'none',
                    margin: 0,
                },
                '&[type="number"]': {
                    MozAppearance: 'textfield',
                    appearance: 'textfield',
                },
            },
        } }));
};
QuantityField.defaultProps = {
    minQuantity: 1,
    maxQuantity: 10,
};
export default QuantityField;
//# sourceMappingURL=QuantityField.js.map